export function formatPlayerTimeWithOffset(seconds, offset) {
  return formatPlayerTime(seconds + offset);
}

export function formatPlayerTime(seconds) {
  if (!seconds || isNaN(seconds) || seconds <= 0) return "00:00:00.0";

  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  const fractional = (seconds % 1).toFixed(1).substring(2);

  return `${hours.toString().padStart(2, "0")}:${mins
    .toString()
    .padStart(2, "0")}:${secs.toString().padStart(2, "0")}.${fractional}`;
}



// WEBPACK FOOTER //
// ./src/utils/videoEditorUtils.js